import { Injectable } from '@angular/core';
import { User } from '../../model';
import { Occ } from '../../occ';
import { Converter } from '../../util';

@Injectable({ providedIn: 'root' })
export class UserProfileSerializer implements Converter<User, Occ.User> {
  constructor() {}

  convert(source: User, target?: Occ.User): Occ.User {
    if (source) {
      if (target === undefined) {
        const { address, legacyAddress, ...src } = source;
        target = src;
        if (legacyAddress) {
          target.addressData = address;
        } else {
          target.companyAddress = address;
        }
      }
    }
    return target;
  }
}
